module.exports = __webpack_public_path__ + "static/media/event-services-img23.3003a75e.jpg";